// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  LANDING_OPTIONS_CENTER_CONTENT_TITLE_PROPS,
  LANDING_OPTIONS_CENTER_CONTENT_DESCRIPTION_PROPS,
} from './constants/landing-options-center-content.constants';
// Styles
import { LandingOptionsCenterContentComponentStyled } from './landing-options-center-content.component.styled';
// Types
import { LandingOptionsOptionComponentType } from '../../types/landing-options.component.type';

const LandingOptionsCenterContentComponent = <T,>({
  description,
  title,
}: Pick<LandingOptionsOptionComponentType<T>, 'description' | 'title'>): React.JSX.Element => (
  <LandingOptionsCenterContentComponentStyled>
    <ParagraphComponent {...LANDING_OPTIONS_CENTER_CONTENT_TITLE_PROPS}>
      <FormattedMessage id={title} />
    </ParagraphComponent>
    <ParagraphComponent {...LANDING_OPTIONS_CENTER_CONTENT_DESCRIPTION_PROPS}>
      <FormattedMessage id={description} />
    </ParagraphComponent>
  </LandingOptionsCenterContentComponentStyled>
);

export { LandingOptionsCenterContentComponent };
